import { useContext } from "react";
import AppContext from "../../AppContext";

const useMe = () => useContext(AppContext);

export default useMe;
